export const animations = {
  big: { spine: 'animations/spine/win/skeleton.json' },
  mega: { spine: 'animations/spine/win/skeleton.json' },
  ultra: { spine: 'animations/spine/win/skeleton.json' },
  multiply: { spine: 'animations/spine/x2/skeleton.json' },
}

export const time = 2
